const getToken = () => {
    return localStorage.getItem('token')
}

const CREATE_CHECKOUT_SESSION = "stripe/CREATE_CHECKOUT_SESSION";
const FETCH_ORDER_ID = "stripe/FETCH_ORDER_ID";
const FETCH_FEES = "stripe/FETCH_FEES";  // New Action

const createCheckoutSession = (session) => ({
    type: CREATE_CHECKOUT_SESSION,
    session
});

const fetchOrderId = (orderId) => ({
    type: FETCH_ORDER_ID,
    orderId
});

const fetchFees = (fees) => ({
    type: FETCH_FEES,
    fees
});

// ✅ Existing: Create PaymentIntent
export const createCheckoutSessionThunk = (tip, customTip, restaurantId, cartItems, coupon, address, name, phone, time, freeItem, rewardItem, email, aptNumber, deliveryInstructions) => async (dispatch) => {
    const token = getToken();

    const response = await fetch(`https://hutaoadmin.onrender.com/api/stripe-new/create-payment-intent`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            credentials: 'include',
            'Authorization': `Bearer ${token}`,
        },
        credentials: 'include',
        body: JSON.stringify({ tip, customTip, restaurantId, cartItems, coupon, address, name, phone, time, freeItem, rewardItem, email, aptNumber, deliveryInstructions })
    });

    if (response.ok) {
        const data = await response.json();
        dispatch(createCheckoutSession(data));
    }
};

// ✅ New: Fetch fees from /get-fees
export const fetchFeesThunk = (tip, customTip, restaurantId, cartItems, coupon, address, needDelivery) => async (dispatch) => {
    const token = getToken();

    const response = await fetch(`https://hutaoadmin.onrender.com/api/stripe-new/get-fees`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            credentials: 'include',
            'Authorization': `Bearer ${token}`,
        },
        credentials: 'include',
        body: JSON.stringify({ tip, customTip, restaurantId, cartItems, coupon, address, needDelivery })
    });

    if (response.ok) {
        const data = await response.json();
        dispatch(fetchFees(data));  // Store fees in state
    }
};

// ✅ Fetch orderId for order confirmation
export const fetchOrderDataThunk = (paymentIntentId) => async (dispatch) => {
    let attempts = 0;
    let orderData = null;

    while (attempts < 3 && !orderData) {
        try {
            const response = await fetch(`https://hutaoadmin.onrender.com/api/orders/webhook-response/${paymentIntentId}`);
            if (response.ok) {
                const data = await response.json();
                if (data) {
                    dispatch(fetchOrderId(data));
                    return data;
                }
            }
        } catch (error) {
            console.error("❌ Error fetching order data:", error);
        }

        attempts++;
        await new Promise(resolve => setTimeout(resolve, 3000));
    }

    console.error("❌ Order data not found after multiple attempts.");
    return null;
};

const initialState = {
    data: null,
    orderId: null,
    feeBreakdown: null  // New state for fees
};

const stripeReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_CHECKOUT_SESSION:
            return {
                ...state,
                data: action.session
            };
        case FETCH_ORDER_ID:
            return {
                ...state,
                orderId: action.orderId
            };
        case FETCH_FEES:
            return {
                ...state,
                feeBreakdown: action.fees
            };
        default:
            return state;
    }
};

export default stripeReducer;
